export default [{
    path: '/language',
    name: 'language',
    meta: {
      layout: 'main'
    },
    component: () => import('@/views/language/index')
  }]
  